import { ALL_SFR_REASONS } from 'api/graphql/v2/queries/SfrReasons';
import { IOption } from 'model';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-apollo';
import { mapToOption } from 'utils/mappers/form';

interface ISfrReason {
  id: number;
  name: string;
  priorityOrder?: number;
}

export const useSfrReasons = () => {
  const [sfrReasons, setSfrReasons] = useState<IOption[]>([]);
  const { data, loading: isSfrReasonsLoading } = useQuery(ALL_SFR_REASONS, {
    fetchPolicy: 'cache-first'
  });

  useEffect(() => {
    if (data?.allSfrReasons) {
      setSfrReasons(
        mapToOption(
          data.allSfrReasons.map((reason: ISfrReason) => ({
            id: reason.id,
            value: reason.name
          }))
        )
      );
    }
  }, [data]);

  return { sfrReasons, isSfrReasonsLoading };
};
